export const ProductImageType = {
  MODEL: "model",
  BUST: "bust"
};
